import { Link } from "@tanstack/react-router";
import { ArrowLeft, Pencil } from "lucide-react";
import { useLingui } from "@lingui/react/macro";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import type { Material } from "@/types/material";

interface MaterialDetailHeaderProps {
  material: Material;
  canEdit: boolean;
  onEdit: () => void;
}

export function MaterialDetailHeader({ material, canEdit, onEdit }: MaterialDetailHeaderProps) {
  const { t } = useLingui();

  return (
    <div className="flex flex-col gap-3 px-3">
      <Link
        to="/materials"
        search={{ page: 1, pageSize: 50, ingredientStatus: "all" }}
        className="inline-flex w-fit items-center gap-1.5 text-sm text-(--color-text-secondary) transition-colors hover:text-(--color-text-primary)"
      >
        <ArrowLeft className="size-4" />
        {t`Back to Materials`}
      </Link>
      <div className="flex items-end justify-between gap-4">
        <div className="flex flex-col gap-1">
          <span className="text-sm text-(--color-text-secondary)">
            {material.company?.name ?? t`Shared`}
          </span>
          <div className="flex items-center gap-3">
            <h1 className="text-4xl leading-none font-semibold tracking-tight text-(--color-text-primary)">
              {material.name}
            </h1>
            <Badge variant={material.isActive ? "success" : "secondary"}>
              {material.isActive ? t`Active` : t`Inactive`}
            </Badge>
          </div>
        </div>
        {canEdit && (
          <Button variant="brand-outline" onClick={onEdit} className="shrink-0">
            <Pencil className="size-4" />
            {t`Edit`}
          </Button>
        )}
      </div>
    </div>
  );
}
